'use client';
import { Flex, Title } from '@gjensidige/builders-components';
import { InfographicsTypes as Props } from './types';
import { Chart } from './chart/chart';
import styles from './infographics.module.less';

export const Infographics = ({ charts, title }: Props) => (
  <Flex center layout="1" className={styles.marginYParts}>
    {!!title && <Title as="h2" size={5} text={title} uppercase />}
    <Flex layout={{ lg: 3, md: 2, xs: 1 }} fill>
      {charts?.map((chart, index) => (
        <Chart
          key={`${chart.title}__${index}`}
          {...chart}
          numberOfCharts={charts.length}
          titleTag={title ? 'h3' : 'h2'}
        ></Chart>
      ))}
    </Flex>
  </Flex>
);
